'use client'

import { useEffect } from 'react'
import { useLocation } from '@/lib/router'
import { trackPageView } from '@/firebase'

/** Sends a GA4 page_view on every client-side route change. */
export default function AnalyticsListener() {
  const location = useLocation()

  useEffect(() => {
    const path = `${location.pathname}${location.search}`
    void trackPageView(path)
  }, [location.pathname, location.search])

  return null
}
